export default function getUserProfileValidate(oUsuario, oMensagemDados) {
  if (!oUsuario) {
    return false
  }

  const oAutorMensagem = oMensagemDados?.message?.usuario ?? oMensagemDados?.message?.user

  if (!oAutorMensagem?.profile && !Array.isArray(oMensagemDados?.ticket?.messages)) {
    return true
  }

  // Carrega os tipos de perfis do usuário logado e da mensagem.
  const cUsuarioLogadoPerfil = oUsuario.profile

  const oAutorFallback = oMensagemDados?.ticket?.messages?.[0]?.usuario ?? oMensagemDados?.ticket?.messages?.[0]?.user

  const cMensagemUsuarioPerfil =
    oAutorMensagem?.profile !== undefined
      ? oAutorMensagem.profile
      : (oAutorFallback?.profile ?? "user")

  const nMensagemUsuarioId =
    oAutorMensagem?.id !== undefined ? oAutorMensagem.id : (oAutorFallback?.id ?? null)

  // Busca o filaId da mensagem, do ticket ou da primeira mensagem no array
  const nMensagemFilaId =
    oMensagemDados.message?.filaId !== undefined
      ? oMensagemDados.message.filaId
      : oMensagemDados.ticket?.queueId !== undefined
        ? oMensagemDados.ticket.queueId
        : (oMensagemDados.ticket?.messages[0]?.filaId ?? null)

  // Usuário ADMIN sempre tem acesso a todas as mensagens.
  if (cUsuarioLogadoPerfil === "admin") {
    return true
  }

  const nTicketResponsavelId = oMensagemDados?.ticket?.responsavelId

  // Responsável atual do ticket vê o histórico completo (ex.: após transferência).
  if (nTicketResponsavelId != null && nTicketResponsavelId === oUsuario.id) {
    return true
  }

  // Verifica se o usuário está vinculado à fila da mensagem. Caso não tenha fila vinculada, todos os usuários têm acesso.
  const lAcessaFila = !nMensagemFilaId || (oUsuario.queues ?? []).some((queue) => queue.id === nMensagemFilaId)

  if (!lAcessaFila) {
    return false
  }

  // Permite acesso se o usuário logado for o mesmo que está vinculado à mensagem.
  if (nMensagemUsuarioId === oUsuario.id) {
    return true
  }

  // Verifica a hierarquia dos perfis.
  // Caso o usuário logado tenha um perfil abaixo do perfil da mensagem, não tem acesso.
  // Caso a mensagem tenha sido enviada pelo bot, só admins tem acesso.
  const mPerfis = ["user", "supervisor", "bot", "admin"]
  const nUsuarioLogadoNivel = mPerfis.indexOf(cUsuarioLogadoPerfil)
  const nMensagemNivel = mPerfis.indexOf(cMensagemUsuarioPerfil)

  if (nUsuarioLogadoNivel < nMensagemNivel) {
    return false
  }

  // Caso os perfis estejam no mesmo nível, verifica se o usuário logado tem permissão para ver mensagens do mesmo perfil.
  if (nUsuarioLogadoNivel === nMensagemNivel && !oUsuario.verMensagensMesmoPerfil) {
    return false
  }

  return true
}
